var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-content',{staticClass:"candidate documents page"},[_c('v-container',[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("\n        My Documents\n      ")]),_c('v-divider'),_c('div',{staticClass:"mb-3"},[_vm._v(" ")]),_c('MyDocumentsSection',{attrs:{"profile":_vm.profile}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }